// Constants for the Procurement flow (Phase 2)

export const REQUEST_PRIORITIES = [
  { value: "truck_down", label: "1 · Truck Down", color: "text-red-700", bg: "bg-red-100", dot: "bg-red-500" },
  { value: "safety_issue", label: "2 · Safety Issue", color: "text-orange-700", bg: "bg-orange-100", dot: "bg-orange-500" },
  { value: "dot_compliance", label: "3 · DOT Compliance", color: "text-amber-700", bg: "bg-amber-100", dot: "bg-amber-500" },
  { value: "scheduled_repair", label: "4 · Scheduled Repair", color: "text-blue-700", bg: "bg-blue-100", dot: "bg-blue-500" },
  { value: "stock_replenishment", label: "5 · Stock Replenishment", color: "text-slate-700", bg: "bg-slate-100", dot: "bg-slate-400" },
];

export const PRIORITY_MAP = Object.fromEntries(REQUEST_PRIORITIES.map((p) => [p.value, p]));

export const REQUEST_STATUSES = {
  submitted: { label: "Submitted", color: "text-slate-700", bg: "bg-slate-100" },
  under_review: { label: "Under Review", color: "text-indigo-700", bg: "bg-indigo-100" },
  approved: { label: "Approved", color: "text-blue-700", bg: "bg-blue-100" },
  reserved: { label: "Reserved", color: "text-teal-700", bg: "bg-teal-100" },
  need_to_purchase: { label: "Need to Purchase", color: "text-amber-700", bg: "bg-amber-100" },
  ordered: { label: "Ordered", color: "text-purple-700", bg: "bg-purple-100" },
  part_received: { label: "Part Received", color: "text-cyan-700", bg: "bg-cyan-100" },
  issued: { label: "Issued", color: "text-green-700", bg: "bg-green-100" },
  installed: { label: "Installed", color: "text-green-700", bg: "bg-green-100" },
  closed: { label: "Closed", color: "text-slate-600", bg: "bg-slate-100" },
  denied: { label: "Denied", color: "text-red-700", bg: "bg-red-100" },
  cancelled: { label: "Cancelled", color: "text-slate-500", bg: "bg-slate-100" },
};

// Allowed next statuses from each status (workflow)
export const REQUEST_NEXT = {
  submitted: ["under_review", "approved", "denied", "cancelled"],
  under_review: ["approved", "need_to_purchase", "denied", "cancelled"],
  approved: ["reserved", "need_to_purchase", "issued", "cancelled"],
  reserved: ["need_to_purchase", "issued", "cancelled"],
  need_to_purchase: ["ordered", "cancelled"],
  ordered: ["part_received", "cancelled"],
  part_received: ["issued", "cancelled"],
  issued: ["installed", "closed"],
  installed: ["closed"],
};

export const PO_STATUSES = {
  draft: { label: "Draft", color: "text-slate-600", bg: "bg-slate-100" },
  submitted: { label: "Submitted", color: "text-indigo-700", bg: "bg-indigo-100" },
  ordered: { label: "Ordered", color: "text-blue-700", bg: "bg-blue-100" },
  partially_received: { label: "Partially Received", color: "text-amber-700", bg: "bg-amber-100" },
  received: { label: "Received", color: "text-green-700", bg: "bg-green-100" },
  closed: { label: "Closed", color: "text-slate-600", bg: "bg-slate-100" },
  cancelled: { label: "Cancelled", color: "text-red-600", bg: "bg-slate-100" },
};

export const PO_NEXT = {
  draft: ["submitted", "ordered", "cancelled"],
  submitted: ["ordered", "cancelled"],
  ordered: ["cancelled"],
  partially_received: [],
  received: ["closed"],
};

export const DISPOSITIONS = [
  { value: "add_to_inventory", label: "Add to Inventory" },
  { value: "use_immediately", label: "Use Immediately" },
  { value: "split", label: "Split (Inventory + Use)" },
];

export const PART_SOURCES = [
  { value: "inventory_stock", label: "Inventory Stock" },
  { value: "direct_purchase", label: "Direct Purchase" },
  { value: "salvaged_unit", label: "Salvaged Unit" },
  { value: "warranty_replacement", label: "Warranty Replacement" },
];
